import React, {
  Fragment,
  useState,
  useCallback,
  useContext,
  useEffect
} from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { SeatsAfterSelectionsInMobileView, Selection } from "./styles";
import { useSelector } from "react-redux";
import { RowButton } from "app/modules/purchase/styles";
import { Button } from "app/components";
import { SeatPlanNote } from "app/modules/purchase/StepSeats/styles";
import { generatePath, useHistory, useLocation } from "react-router-dom";

import ConfigContext from "app/context/config";
import { useConfig } from "app/hooks";
// import { Selection } from './styles';

const propTypes = {
  row: PropTypes.string,
  seats: PropTypes.string,
  totalPrice: PropTypes.number,
  isOrdered: PropTypes.boolean,
  buy: PropTypes.func.isRequired,

  seatsDescription: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
      amount: PropTypes.number.isRequired
    })
  )
};

const defaultProps = {
  row: "-",
  seats: "-",
  totalPrice: 0,
  seatsDescription: []
};

const SelectionTotalMobile = ({
  row,
  seats,
  totalPrice,
  seatsDescription,
  isOrdered,
  buy
}) => {
  const [t] = useTranslation();
  const [isExpanded, toggleExpand] = useState(false);
  const sessionData = useSelector(state => state.sessions);
  const orderData = useSelector(state => state.order);
  const currencyForCountry = value => {
    switch (value) {
      case "bih": {
        return "KM";
      }

      case "rou": {
        return "LEI";
      }

      case "aut": {
        return "EUR";
      }

      case "srb": {
        return "RSD";
      }

      case "alb": {
        return "ALL";
      }

      case "bil": {
        return "KM";
      }

      case "grc": {
        return "€";
      }

      case "hrv": {
        return "€";
      }

      case "mkd": {
        return "ДЕН";
      }

      case "mne": {
        return "€";
      }

      case "rks": {
        return "€";
      }

      case "svn": {
        return "€";
      }

      default: {
        return "";
      }
    }
  };

  const { routes } = useContext(ConfigContext);
  const [windowSize, setWindowSize] = useState(getWindowSize());
  const country = process.env.REACT_APP_COUNTRY;

  const location = useLocation();
  const cinemas = useSelector(state => state?.cinemas?.cinemas);
  const concessionsaleData = cinemas?.filter((item) => {
    const cinemaId = location?.pathname?.split("/")[3]?.split('-')[0];
    return item?.id === cinemaId;
  });
  const movieCinemaId = sessionStorage.getItem("movieCinemaId");
  const email = location?.state?.email;
  const history = useHistory();
  const next = useCallback(() => {
    // concessionsaleData[0]?.concessionsale
    //   ? history.push(generatePath(routes.stepSnacksAndDrinks.pattern, { movieCinemaId }))
    //   : history.push(generatePath(routes.stepCheckout.pattern, { movieCinemaId }))
    // eslint-disable-next-line
    if (email && orderData) {
      buy(orderData?.userSessionId, email);
    } else if (country === 'aut' && concessionsaleData[0]?.concessionsale) {
      history.push(generatePath(routes.stepSnacksAndDrinks.pattern, { movieCinemaId }));
    } else {
      // history.push(generatePath(routes.stepCheckout.pattern, { movieCinemaId }));
      history.push({
        pathname: generatePath(routes.stepCheckout.pattern, { movieCinemaId }),
        state: { isAboId: location?.state?.isAboId }
      });
    }
  }, [movieCinemaId, orderData]);

  useEffect(() => {
    function handleWindowSize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener("resize", handleWindowSize);

    return () => {
      window.removeEventListener("resize", handleWindowSize);
    };
  }, []);

  function getWindowSize() {
    const { innerWidth, innerHeight } = window;

    return { innerWidth, innerHeight };
  }

  return (
    <Fragment>
      {isOrdered &&
        windowSize.innerWidth <= 992 &&
        (sessionData?.wizard?.isBonus ? (
          <div>
            <RowButton>
              <Button
                isPrimary
                disabled={
                  sessionData?.session?.userBalance?.cardBalance <
                  totalPrice / 100
                }
                onClick={next}
              >
                {t("purchase.next")}
              </Button>
            </RowButton>
            {sessionData?.session?.userBalance?.cardBalance <
              totalPrice / 100 ? (
              <SeatPlanNote style={{ color: "#de1619" }}>
                {t("purchase.bonus_card_less_balance")}
              </SeatPlanNote>
            ) : (
              ""
            )}
            <SeatPlanNote>{t("purchase.plan_note")}</SeatPlanNote>
          </div>
        ) : (
          <>
            {location.pathname.split("/")[4] === "seats" ? (
              <SeatsAfterSelectionsInMobileView>
                <RowButton>
                  <Button
                    isPrimary
                    onClick={next}
                    className={isOrdered && email ? "pay_btn_position" : ""}
                  >
                    {/* {t('purchase.next')} */}
                    {!email ? t("purchase.next") : t("purchase.pay")}
                  </Button>
                </RowButton>
                <SeatPlanNote>{t("purchase.plan_note")}</SeatPlanNote>
              </SeatsAfterSelectionsInMobileView>
            ) : null}
          </>
        ))}
      <Selection className={isExpanded ? "_expanded" : ""}>
        <div
          className="b-selection-total-mob__mask"
          aria-hidden
          onClick={() => seatsDescription.length && toggleExpand(!isExpanded)}
        />

        {isOrdered && email && (
          <div
            className="b-selection-total-mob__info-wrapper"
            aria-hidden
            onClick={() => seatsDescription.length && toggleExpand(!isExpanded)}
          >
            <div className="b-selection-total-mob__info">
              <div className="b-selection-total-mob__info-inner">
                <p className="b-selection-total-mob__info-title">
                  {t("purchase.row")}
                </p>
                <p className="b-selection-total-mob__info-value">{row}</p>
              </div>

              <div className="b-selection-total-mob__info-inner">
                <p className="b-selection-total-mob__info-title">
                  {t("purchase.seats")}
                </p>
                <p className="b-selection-total-mob__info-value">{seats}</p>
              </div>
            </div>

            <div className="b-selection-total-mob__info">
              <div className="b-selection-total-mob__info-inner">
                <p className="b-selection-total-mob__info-title">
                  {t("purchase.total")}
                </p>
                <p className="b-selection-total-mob__info-value">
                  {t("show_price", { price: totalPrice / 100 }) +
                    currencyForCountry(process.env.REACT_APP_COUNTRY)}
                </p>
              </div>
              {seatsDescription.length ? (
                <span className="_with-chevron" />
              ) : null}
            </div>
          </div>
        )}

        {isOrdered && !email && (
          <div
            className="b-selection-total-mob__info-wrapper"
            aria-hidden
            onClick={() => seatsDescription.length && toggleExpand(!isExpanded)}
          >
            <div className="b-selection-total-mob__info">
              <div className="b-selection-total-mob__info-inner">
                <p className="b-selection-total-mob__info-title">
                  {t("purchase.row")}
                </p>
                <p className="b-selection-total-mob__info-value">{row}</p>
              </div>

              {/* <div className="b-selection-total-mob__info">
              <div className="b-selection-total-mob__info-inner">
                <p className="b-selection-total-mob__info-title">
                  {t("purchase.total")}
                </p>
                <p className="b-selection-total-mob__info-value">
                  {`${totalPrice / 100} ${currencyForCountry(process.env.REACT_APP_COUNTRY)}`}
                </p>
              </div>
              {seatsDescription.length ? (
                <span className="_with-chevron" />
              ) : null}
            </div> */}
            </div>

            <div className="b-selection-total-mob__info">
              <div className="b-selection-total-mob__info-inner">
                <p className="b-selection-total-mob__info-title">
                  {t("purchase.total")}
                </p>
                <p className="b-selection-total-mob__info-value">
                  {`${totalPrice / 100} ${currencyForCountry(
                    process.env.REACT_APP_COUNTRY
                  )}`}
                </p>
              </div>
              {seatsDescription.length ? (
                <span className="_with-chevron" />
              ) : null}
            </div>
          </div>
        )}

        {seatsDescription.length ? (
          <div className="b-selection-total-mob__description">
            {seatsDescription.map(seat => {
              const info = [
                seat.amount,
                `${totalPrice / 100} ${currencyForCountry(
                  process.env.REACT_APP_COUNTRY
                )}`
              ];

              return (
                <div
                  className="b-selection-total-mob__description-inner"
                  key={seat.title}
                >
                  <p className="b-selection-total-mob__description-text">
                    {seat.title}
                  </p>
                  <p className="b-selection-total-mob__info-description-text">
                    {info.join(" x ")}
                  </p>
                </div>
              );
            })}
          </div>
        ) : null}
      </Selection>
    </Fragment>
  );
};

SelectionTotalMobile.propTypes = propTypes;
SelectionTotalMobile.defaultProps = defaultProps;
export default SelectionTotalMobile;
